import { MdClose } from 'react-icons/md';

import { Button, Group } from '@ui';

type RemoveButtonProps = {
  handleRemove: () => void;
};

/**
 *
 * @description Use this with ArrayForms
 */
const RemoveButton = ({ handleRemove }: RemoveButtonProps) => {
  return (
    <Group justify="flex-end">
      <Button
        size="sm"
        onClick={handleRemove}
        color="danger"
        variant="outline"
        leftSection={<MdClose />}
      >
        Remove
      </Button>
    </Group>
  );
};

export { RemoveButton };
